import { render } from "./EditPoll.vue?vue&type=template&id=3897657d&scoped=true"
import script from "./EditPoll.vue?vue&type=script&lang=ts"
export * from "./EditPoll.vue?vue&type=script&lang=ts"

import "./EditPoll.vue?vue&type=style&index=0&id=3897657d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3897657d"

export default script